module.exports = __webpack_public_path__ + "school/img/shehuizhuyi.8cb1c13a.jpg";